import { Radio, Stack, TableCell, Typography, useTheme } from '@mui/material';
import { StackedTextCell } from '@retail/components';
import { SupplierWithActiveAgreement } from '@retail/purchase-agreements/components';
import { useFetchPurchaseAgreements } from '@retail/purchase-agreements/data-access';
import { PurchaseAgreement } from '@retail/purchase-agreements/types';

interface Props {
  supplierWithActiveAgreement: SupplierWithActiveAgreement;
  handleUpdate: (agreement: PurchaseAgreement, supplierId: number) => void;
}

export function SupplierAgreements({ supplierWithActiveAgreement, handleUpdate }: Props) {
  const theme = useTheme();
  const palette = theme.vars.palette;
  const { data: purchaseAgreementDtos = [] } = useFetchPurchaseAgreements({
    supplierId: supplierWithActiveAgreement.supplier.mgSupplierId,
  });
  const purchaseAgreements = purchaseAgreementDtos.map(PurchaseAgreement.fromDto);
  return (
    <>
      {purchaseAgreements.map((agreement) => (
        <TableCell
          key={agreement.id}
          sx={{
            borderRight: `1px solid ${palette.grey[100]}`,
            borderBottom: `1px solid ${palette.grey[100]}`,
            borderTop: `1px solid ${palette.grey[100]}`,
          }}
        >
          <Stack display="flex" alignItems="center">
            <StackedTextCell
              centerAlign
              topLine={
                <Typography variant="body3" whiteSpace="nowrap">
                  {agreement.name}
                </Typography>
              }
              bottomLine={
                <Radio
                  sx={{ padding: 0.5 }}
                  onClick={() =>
                    handleUpdate(agreement, supplierWithActiveAgreement.supplier.mgSupplierId)
                  }
                  checked={supplierWithActiveAgreement.activeAgreement?.id === agreement.id}
                />
              }
            />
          </Stack>
        </TableCell>
      ))}
    </>
  );
}
